import { S3 } from '@aws-sdk/client-s3'
import { Upload } from '@aws-sdk/lib-storage'
import { findAwsRegionForAzureRegion } from 'src/utils/csp/regions'

export const uploadFileToCloud = async (
  uploadFileTempCreds: any,
  node: any,
  destinationKey: string,
  file: File,
  copyStrategyValue: string,
  readAccessValue: string,
  writeStrategyValue: string,
  onUploadProgress: (progress: { name?: string; loaded?: number; total?: number }) => void,
  skipVendiaPrefix?: boolean,
) => {
  return uploadFileToBucket(
    uploadFileTempCreds,
    node,
    destinationKey,
    file,
    copyStrategyValue,
    readAccessValue,
    writeStrategyValue,
    onUploadProgress,
    skipVendiaPrefix,
  )
}

async function uploadFileToBucket(
  uploadFileTempCreds: any,
  node: any,
  destinationKey: string,
  file: File,
  copyStrategyValue: string,
  readAccessValue: string,
  writeStrategyValue: string,
  onUploadProgress: (progress: { name?: string; loaded?: number; total?: number }) => void,
  skipVendiaPrefix?: boolean,
) {
  const upload = new Upload({
    client: new S3({
      credentials: {
        accessKeyId: uploadFileTempCreds.accessKeyId,
        secretAccessKey: uploadFileTempCreds.secretAccessKey,
        sessionToken: uploadFileTempCreds.sessionToken,
      },
      region: node.csp === 'azure' ? findAwsRegionForAzureRegion(node.region) : node.region,
    }),
    params: {
      Bucket: node.uploadBucket,
      Key: skipVendiaPrefix ? destinationKey : `_VENDIA/uploads/${destinationKey}`,
      Body: file,
      Metadata: getMetadata(destinationKey, copyStrategyValue, readAccessValue, writeStrategyValue, '-'),
    },
  })

  upload.on('httpUploadProgress', (progress) =>
    onUploadProgress({ name: progress.Key!.split('/').pop(), loaded: progress.loaded, total: progress.total }),
  )

  const completedUpload = await upload.done()
  return completedUpload.VersionId
}

function getMetadata(
  destinationKey: string,
  copyStrategyValue: string,
  readAccessValue: string,
  writeStrategyValue: string,
  delimiter: string,
) {
  const metadata = {} as Record<string, string>

  const copyStrategyKey = ['vendia', 'lfu', 'file', 'copy', 'strategy'].join(delimiter)
  metadata[copyStrategyKey] = copyStrategyValue

  const readKey = ['vendia', 'lfu', 'file', 'read', 'permissions'].join(delimiter)
  metadata[readKey] = readAccessValue.toString()

  const writeKey = ['vendia', 'lfu', 'file', 'write', 'permissions'].join(delimiter)
  metadata[writeKey] = writeStrategyValue.toString()

  const destinationKeyKey = ['vendia', 'lfu', 'file', 'destination', 'key'].join(delimiter)
  metadata[destinationKeyKey] = destinationKey

  const ignoreUploadKey = ['vendia', 'ignore', 'file', 'upload'].join(delimiter)
  metadata[ignoreUploadKey] = 'true'

  return metadata
}
